import changeLanguage from './ChangeLanguage';
import initI18n from './InitI18n';

export { initI18n, changeLanguage };



// WEBPACK FOOTER //
// ./src/redux/sagas/Localization/index.ts